module.exports = __webpack_public_path__ + "static/img/bonus_9.9260324.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dglfr/bonus_9.png
// module id = 34OO
// module chunks = 0